<!-- 选择车系 -->
<template>
    <div id="chooseCarType" class="chooseCarType" v-loading="loading">
        <div class="tabs-btn-ctn">
            <div class="tab-btn-item" @click="tabToggle(0)" :class="{'tab-active':tabInd == 0}">库存列表</div>
            <div class="tab-btn-item" @click="tabToggle(1)" :class="{'tab-active':tabInd == 1}">配件库</div>
            <!-- <div class="tab-btn-item" @click="tabToggle(2)" :class="{'tab-active':tabInd == 2}">服务商品</div> -->
            <el-button size="small" class="btn-primary createPJ" @click="createPJ">直接创建</el-button>
        </div>
        <div class="nomal-tabs-content">
            <!-- 库存列表 -->
            <div class="nomal-tab-section sp-ctn" v-show="tabInd == 0 ">
                <div class="search-ctn">
                    <el-input placeholder="配件名称或配件编码" class="search-input" v-model="inventorySearchData.key"></el-input>
                    <el-button slot="append" class="btn-primary" icon="el-icon-search" @click="getInventory">搜索</el-button>
                </div>
                <div>
                    <div class="pl-ctn">
                        <el-card class="box-card pj-item" v-for="(item,index) in inventoryList" :key="item.Id">
                            <div  @click="chooseInventory(item,index,0)" class="qp-ctn">
                                <div class="qp-cover">
                                    <img :src="item.MainImg ? QN_URL_BASE+item.MainImg+'?imageView2/2/w/200' : ''" alt="" :onerror="defaultImg">
                                </div>
                                <div class="qp-msg">
                                    <p>汽配名称：{{item.GoodName}}</p>
                                    <p>编码：{{item.APCode}}</p>
                                    <p>价格：<span class="color-red">￥{{item.Price}}</span></p>
                                </div>
                                <i class="el-icon-circle-check choose-icon no-choose" :class="{'pj-choosed':item.choosed}"></i>
                            </div>
                        </el-card>
                    </div>
                    <div class="dialog-pagination-ctn">
                        <el-pagination
                                @size-change="inventorySizeChange"
                                @current-change="inventoryCurrentChange"
                                :current-page="inventorySearchData.page"
                                :page-sizes="[12, 20, 30, 40, 50]"
                                :page-size="inventorySearchData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="inventoryLength">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <!-- 商品列表 -->
            <div class="nomal-tab-section sp-ctn" v-show="tabInd == 1 ">
                <div class="search-ctn">
                    <el-input placeholder="配件名称或配件编码" class="search-input" v-model="goodsSearchData.key"></el-input>
                    <el-button slot="append" class="btn-primary" icon="el-icon-search" @click="getGoodsData">搜索</el-button>
                </div>
                <div>
                    <div class="pl-ctn">
                        <el-card class="box-card pj-item" v-for="(item,index) in goodsList" :key="item.Id">
                            <div  @click="chooseGoods(item,index,1)" class="qp-ctn">
                                <div class="qp-cover">
                                    <img :src="item.PublicUrl?QN_URL_BASE+item.PublicUrl+'?imageView2/2/w/200':''" alt="" :onerror="defaultImg">
                                </div>
                                <div class="qp-msg">
                                    <p>汽配名称：{{item.Cn}}</p>
                                    <p>编码：{{item.Code }}</p>
                                    <!--<p>价格：<span class="color-red">￥{{item.CostPrice}}</span></p>-->
                                </div>
                                <i class="el-icon-circle-check choose-icon no-choose" :class="{'pj-choosed':item.choosed}"></i>
                            </div>
                        </el-card>
                    </div>
                    <div class="dialog-pagination-ctn">
                        <el-pagination
                                @size-change="goodsSizeChange"
                                @current-change="goodsCurrentChange"
                                :current-page="goodsSearchData.page"
                                :page-sizes="[12, 20, 30, 40, 50]"
                                :page-size="goodsSearchData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="goodsLength">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <!-- 服务商品 -->
            <div class="nomal-tab-section sp-ctn" v-show="tabInd == 2 ">
                <div class="search-ctn">
                    <el-input placeholder="配件名称" class="search-input" v-model="serveSearchData.goodsName"></el-input>
                    <el-button slot="append" class="btn-primary" icon="el-icon-search" @click="getServeData">搜索</el-button>
                </div>
                <div>
                    <div class="pl-ctn">
                        <el-card class="box-card pj-item" v-for="(item,index) in serveList" :key="item.Id">
                            <div  @click="chooseServe(item,index,2)" class="qp-ctn">
                                <div class="qp-cover">
                                    <img :src="+item.MainImg?QN_URL_BASE+item.MainImg+'?imageView2/2/w/200':''" alt="" :onerror="defaultImg">
                                </div>
                                <div class="qp-msg">
                                    <p :title="item.GoodName">商品名称：{{item.GoodName}}</p>
                                    <p>价格：<span class="color-red">￥{{item.Price}}</span></p>
                                </div>
                                <i class="el-icon-circle-check choose-icon no-choose" :class="{'pj-choosed':item.choosed}"></i>
                            </div>
                        </el-card>
                    </div>
                    <div class="dialog-pagination-ctn">
                        <el-pagination
                                @size-change="serveSizeChange"
                                @current-change="serveCurrentChange"
                                :current-page="serveSearchData.page"
                                :page-sizes="[12, 20, 30, 40, 50]"
                                :page-size="serveSearchData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="serveLength">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer" style="text-align: right">
                <el-button @click="clearDataAndClose()">取 消</el-button>
                <el-button class="btn-primary" @click="emitData">确 定</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'choosePJ',
        components: {},
        data(){
             let userMsg = this.$util.getLocalStorage("userMsg");
            return {
                loading: false,
                tabInd:0,
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE + '"',
                QN_URL_BASE:this.$util.QN_URL_BASE,
                choosedPJ:[],
                // 库存
                inventoryList:[],
                inventoryLength:0,
                inventorySearchData:{
                    entpId:userMsg.EntpId,
                    page:1,
                    limit:12,
                    key:'',
                },
                inventorySelected:[],

                // 商品
                goodsList:[],
                goodsLength:0,
                goodsSearchData:{
                    Code:'',
                    Name:'',
                    SId:'',
                    page: 1,
                    limit: 12,
                    key:''
                },
                goodsSelected:[],

                // 服务商品
                serveList:[],
                serveLength:0,
                serveSearchData:{
                    entpId:userMsg.EntpId,
                    goodsName:'',
                    page:1,
                    limit:12,
                    key:'',
                },
                serveSelected:[],

            }
        },
        mounted(){
            this.getInventory()
            // this.getGoodsData()
            // this.getServeData()
        },
        methods:{
            // 直接创建配件
            createPJ(){
                let _data = [{
                    MainImg:'',
                    Source:'3',
                    GoodId:'',
                    GoodName:'',
                    MarketPrice:0,
                    CostPrice:0,
                    ShopPrice:0,
                    Discount:0,
                    Count:1,
                    InstallationFee:0,
                }]
                this.$emit('choosePJ',_data)
            },
            // 获取库存
            getInventory(){
                this.loading=true;
                this.$util.axiosGet({
                    url:'/api/CustomerManagement/GetInventoryPartsList',
                    data:this.inventorySearchData,
                    hideLoading:true
                }).then((res)=>{
                    let data =res.data
                    for (let i = 0; i < data.length;i++){
                        let flag = false
                        for (let j = 0;j<this.choosedPJ.length;j++){
                            if (this.choosedPJ[j].GoodId == data[i].GoodId){
                                flag = true
                                break
                            }
                        }
                        data[i].choosed = flag
                    }
                    this.inventoryList = data
                    this.inventoryLength = res.count
                    this.loading=false;
                }).catch(()=>{this.loading=false;})
            },
            // 选择库存
            chooseInventory(item,index,Source){
                let flag = this.inventoryList[index].choosed
                if (flag){
                    this.inventoryList[index].choosed = false
                    for (let i = 0;i < this.choosedPJ.length;i++){
                        if (this.choosedPJ[i].GoodId == item.GoodId){
                            this.choosedPJ.splice(i,1)
                        }
                    }
                }
                else {
                    this.inventoryList[index].choosed = true
                    let _data = {
                        MainImg:item.MainImg,
                        Source:Source,
                        GoodId:item.GoodId,
                        GoodName:item.GoodName,
                        MarketPrice:item.CostPrice,//市场原价：这里的市场价格是，车回佳的商品表的市场原价的价格
                        CostPrice:item.Price,//成本价：成本价是车回佳售卖给汽修厂的价格
                        ShopPrice:item.Price,//平台价格，这个就是给用户的最终价格,
                        Discount:0,
                        Count:1,
                        InstallationFee:0,
                    }
                    this.choosedPJ.push(_data)
                }
            },

            // 获取商品列表
            getGoodsData(){
                this.loading=true;
                this.$util.axiosGet({
                    url:'/api/AutoParts/LoadAutoParts',
                    data:this.goodsSearchData,
                    hideLoading:true
                }).then((res)=>{
                    let data =res.data
                    for (let i = 0; i < data.length;i++){
                        let flag = false
                        for (let j = 0;j<this.choosedPJ.length;j++){
                            if (this.choosedPJ[j].GoodId == data[i].Id){
                                flag = true
                                break
                            }
                        }
                        data[i].choosed = flag
                    }
                    this.goodsList = data
                    this.goodsLength = res.count
                    this.loading=false;
                }).catch(()=>{this.loading=false;})
            },
            // 选择商品
            chooseGoods(item,index,Source){
                let flag = this.goodsList[index].choosed
                if (flag){
                    this.goodsList[index].choosed = false
                    for (let i = 0;i < this.choosedPJ.length;i++){
                        if (this.choosedPJ[i].GoodId == item.Id){
                            this.choosedPJ.splice(i,1)
                        }
                    }
                }
                else {
                    this.goodsList[index].choosed = true
                    let _data = {
                        MainImg:item.PublicUrl,
                        Source:Source,
                        GoodId:item.Id,
                        GoodName:item.Cn,
                        MarketPrice:0,
                        CostPrice:0,
                        ShopPrice:0,
                        Discount:0,
                        Count:1,
                        InstallationFee:0,
                    }
                    this.choosedPJ.push(_data)
                }
            },

            // 获取服务商品
            getServeData(){
                this.loading=true;
                this.$util.axiosGet({
                    url:'/api/CustomerManagement/GetServiceChargeProductList',
                    data:this.serveSearchData,
                    hideLoading:true
                }).then((res)=>{
                    let data =res.data
                    for (let i = 0; i < data.length;i++){
                        let flag = false
                        for (let j = 0;j<this.choosedPJ.length;j++){
                            if (this.choosedPJ[j].GoodId == data[i].GoodId){
                                flag = true
                                break
                            }
                        }
                        data[i].choosed = flag
                    }
                    this.serveList = data
                    this.serveLength = res.count
                    this.loading=false;
                }).catch(()=>{this.loading=false;})
            },
            // 选择服务商品
            chooseServe(item,index,Source){
                let flag = this.serveList[index].choosed
                if (flag){
                    this.serveList[index].choosed = false
                    for (let i = 0;i < this.choosedPJ.length;i++){
                        if (this.choosedPJ[i].GoodId == item.GoodId){
                            this.choosedPJ.splice(i,1)
                        }
                    }
                }
                else {
                    this.serveList[index].choosed = true
                    let _data = {
                        MainImg:item.MainImg,
                        Source:Source,
                        GoodId:item.GoodId,
                        GoodName:item.GoodName,
                        MarketPrice:item.Price,
                        CostPrice:item.Price,
                        ShopPrice:item.Price,
                        Discount:0,
                        Count:1,
                        InstallationFee:0,
                    }
                    this.choosedPJ.push(_data)
                }
            },


            // 清空并关闭弹窗
            clearDataAndClose(){
                for (let i=0;i<this.inventoryList.length;i++){
                    this.inventoryList[i].choosed = false
                }
                for (let i=0;i<this.goodsList.length;i++){
                    this.goodsList[i].choosed = false
                }
                for (let i=0;i<this.serveList.length;i++){
                    this.serveList[i].choosed = false
                }
                this.choosedPJ = []
                this.tabInd = 0;
                this.$emit('choosePJ')
            },
            // 删除已选配件
            removePJ (index,item){
                this.choosedPJ.splice(index,1)
                for (let i = 0;i < this.plData.length;i++){
                    if (this.plData[i].Id == item.Id){
                        this.plData[i].choosed = false
                    }
                }
            },
            // 数据传递出去
            emitData(){
                this.$emit('choosePJ',this.choosedPJ)
                this.choosedData =[]
                this.choosedPJ = []
                this.active = 0;
                for (let i = 0; i < this.goodsList.length;i++){
                    this.goodsList[i].choosed = false
                }
            },
            // 切换最上面的tab
            tabToggle(i) {
                this.tabInd = i;
                if(i==0&&(!this.inventoryList||this.inventoryList.length==0))
                    this.getInventory();
                else if(i==1&&(!this.goodsList||this.goodsList.length==0))
                    this.getGoodsData();    
                else if(i==2&&(!this.serveList||this.serveList.length==0))    
                    this.getServeData();
            },
            inventorySizeChange(val){
                this.inventorySearchData.limit = val
                this.getInventory()
            },
            inventoryCurrentChange(val){
                this.inventorySearchData.page = val
                this.getInventory()
            },
            goodsSizeChange(val) {
                this.goodsSearchData.limit = val
                this.getGoodsData()
            },
            goodsCurrentChange(val) {
                this.goodsSearchData.page = val
                this.getGoodsData()
            },
            serveSizeChange(val) {
                this.serveSearchData.limit = val
                this.getServeData()
            },
            serveCurrentChange(val) {
                this.serveSearchData.page = val
                this.getServeData()
            },
        }
    }
</script>
<style lang="less" scoped>
    .createPJ {
        position: absolute;
        top: 0;
        right: 0;
    }
    .qp-ctn {
        padding: 10px;
    }
    .qp-item {
        margin-right: 20px;
    }
    .choosed {
        padding-bottom: 30px;
    }
    .no-data {
        text-align: center;
        font-size: 18px;
        margin-top: 20px;
        width: 100%;
    }
    .tabs-btn-ctn{
        position: relative;
        border-bottom: 1px solid @border1Color;
        .tab-btn-item {
            flex-grow: 0;
            width: 120px;
            padding: 0 10px;
            border-bottom: none;
        }
    }
    .choose-progress {
        padding: 20px 20px 20px 0 ;
    }
    .choose-item {
        border: 1px solid @theme;
        padding: 5px 10px;
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 5px;
        i {
            cursor: pointer;
        }
    }
    .car-sort {
        padding: 20px 0;
        display: flex;
    }
    .active {
        background: @theme;
        color: #fff;
    }
    .sort-item {
        padding: 5px 10px;
        font-weight: bold;
        cursor: pointer;
    }
    .car-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .car-item {
        display: flex;
        align-items: center;
        width: 165px;
        height: 52px;
        border: 1px solid @border1Color;
        margin-bottom: 20px;
        margin-right: 20px;
        cursor: pointer;
        &:hover {
            border: 1px solid @theme;
        }
    }
    .car-logo {
        width: 30px;
        height: 30px;
        margin: 0 20px 0 30px;
    }
    .sp-ctn {
        padding-top: 20px;
    }
    .car-orange {
        background: @border4Color;
        padding: 10px 20px;
        border-left:5px solid @theme ;
        margin-bottom: 10px;
    }
    .cx-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .sp-item {
        width: 162px;
        line-height: 52px;
        border: 1px solid @border4Color;
        text-align: center;
        margin: 0 10px 10px 0;
        cursor: pointer;
        &:hover {
            border: 1px solid @theme;
        }
    }
    .pl-ctn {
        display: flex;
        flex-wrap: wrap;
        max-height: 350px;
        overflow: auto;
    }
    .choose-success {
        font-size: @font-lg;
        line-height: 80px;
        text-align: center;
    }
    .search-ctn {
        height: 60px;
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .search-input {
        width: 80%;
        margin-right: 10px;
    }
    .pj-search {
        display: flex;
        padding-right: 30%;
        margin-bottom: 20px;
    }
    .pj-cover {
        width: 100%;
        height: 100px;
    }
    .pj-item {
        width: 250px;
        margin-right: 10px;
        margin-bottom: 20px;
        position: relative;
    }
    .pj-msg,.qp-msg {
        margin-top: 10px;
        line-height: 1.5em;
        cursor: pointer;
    }
    .choose-icon {
        font-size: 24px;
        position: absolute;
        right: 10px;
        bottom: 10px;
    }
    .no-choose {
        color: @border3Color;
    }
    .pj-choosed {
        color: #67C23A;
    }
    .qp-cover {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin-bottom: 10px;
        height: 228px;
        img {
            max-width: 228px;
            max-height: 228px;
        }
    }
    .dialog-pagination-ctn{
     text-align: left;   
    }
</style>
